import React, { useState } from 'react';

// Input de cantidad que deja borrar el valor mientras se escribe.
// Antes el padre normalizaba en cada tecla (vacio o NaN -> 1), asi que el "1"
// que viene por defecto no se podia borrar: al escribir "3" quedaba "13".
// Ahora el campo se queda con un borrador local mientras se tipea, le avisa al
// padre solo cuando hay un numero valido, y al salir del foco vuelve al ultimo
// valor bueno si quedo vacio. Ademas selecciona todo al enfocar, para que
// escribir reemplace en vez de agregarse al valor que ya estaba.
export const CampoCantidad = ({ value, min = 1, max, onChange, className, crecerConContenido = false, ...resto }) => {
    const [borrador, setBorrador] = useState(null);
    const textoMostrado = borrador !== null ? borrador : value;
    // Ancho en "ch" (ancho del caracter "0" en la tipografía actual): crece
    // con la cantidad de dígitos tipeados (ej. "300" pide más lugar que "1"),
    // en vez de un input fijo estirado por flex que deja el número lejos de
    // las flechitas. Opt-in por prop para no tocar los otros usos del campo.
    const estiloAncho = crecerConContenido
        ? { width: `${Math.max(String(textoMostrado).length, 1) + 0.3}ch` }
        : undefined;

    const alEscribir = (e) => {
        const texto = e.target.value;
        setBorrador(texto);
        if (texto === '') return; // vacio transitorio: no molestamos al padre
        const numero = parseInt(texto, 10);
        if (isNaN(numero)) return;
        onChange(numero);
        // Si el padre lo va a recortar (fuera de min/max), soltamos el borrador
        // para mostrar el valor recortado de verdad y no uno que no existe.
        const hayMax = max !== undefined && max !== null;
        if (numero < min || (hayMax && numero > max)) {
            setBorrador(null);
        }
    };

    return (
        <input
            type="number"
            inputMode="numeric"
            className={className}
            style={estiloAncho}
            min={min}
            max={max}
            value={textoMostrado}
            onChange={alEscribir}
            onFocus={(e) => e.target.select()}
            onBlur={() => setBorrador(null)}
            {...resto}
        />
    );
};

export default CampoCantidad;
